import { useT } from "@/lib/translation";

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const InstagramIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    aria-hidden="true"
  >
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export default function SocialLinks({
  withLabel = true,
}: {
  withLabel?: boolean;
}) {
  const t = useT();
  return (
    <span className="flex items-center gap-2">
      <a
        href="https://x.com/OitavaApp"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 hover:underline"
      >
        {withLabel && t("nav:social.followUs")}
        <XIcon />
      </a>
      <a
        href="https://www.instagram.com/oitavaapp/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center hover:underline"
        aria-label={t("nav:social.instagramLabel")}
      >
        <InstagramIcon />
      </a>
    </span>
  );
}
